import '@/assets/style/companyList.scss';

import { useDeleteApi } from '@/apiError/apiDelete';
import { useTransactionContext } from '@/context/TransactionContext';
import { useSearchReport } from '@/pages/reports/reuse/DynamicReportFunction';
import ListHeaderComponents from '@/pages/reports/reuse/ListHeaderComponents';
import { generateDynamicColumns } from '@/tables/DynamicTableFetchFunction';
import DeleteModalButton from '@/utils/components/DeleteModalButton';
import EditButton from '@/utils/components/EditButton';
import GlobalModal from '@/utils/modal/Modal';
import DynamicTable from '@/utils/table/DynamicTable';
import { Button, Card, Col, Form, Input, message, Row, Select } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import CancelModalButton from '@/utils/components/CancelModalButton';
import { useUpdateApi } from '@/apiError/apiUpdate';
import { useForm } from 'antd/es/form/Form';
import { Back } from '@/utils/routerPath/NavigationHelper';
import { last7DaysObject } from '@/common/custom-date-selector copy/helpers';
import { useLocation } from 'react-router-dom';
import { salesOrderSkeletonTableHeader } from '@/utils/tableHeader';
import { useReactToPrint } from 'react-to-print';
import { useGetApiListNoToast, useMutateGetApi } from '@/apiError/apiShow';
import { PrintFormatRenderer } from '@/features/format-designer/PrintFormatRenderer';
import { getPrintFormatFromTemplate } from '@/utils/transaction/jewelry-new-sticker/buildBillTemplatePayload';
import {
  mapAppToBusiness,
  mapRawSummaryToTokenContext,
} from '@/shared/utils/invoiceMapper';
import useAppData from '@/hooks/useAppData';
import { PrinterOutlined } from '@ant-design/icons';
import { formatNumberWithComma } from '@/utils/formula/CodeWindow';
import DraggableModal from '@/common/ant-components/DraggableModal';
import useDebounce from '@/hooks/useDebounce';

/**
 * Ledger Component
 * Displays and manages ledger data with searches , delete and edit functionalities.
 * Displays and manages ledger data with searches , delete and edit functionalities.
 *
 * @component
 * @returns {React.ReactElement} Ledger Management interface.
 */

const SalesQuotationList = () => {
  const {
    setEditApiBlock,
    setpurchaseTableData,
    setSelectedItems,
    setSalesSelectedData,
    setPrefixResponse,
    clearAllStates,
    setSelectedDataSo,
    setReceiveTabledata,
    setSelectedData,
    setSalesOrderSelectedData,
    salesOrderSelectedData,
    setSalesOrderTableData,
    setPurchaseNetAmount,
    setSalesSelectReferenceId,
    salesStartDate,
    salesEndDate,
    setPurchaseFinalJson,
    setHiddenValueChange,
    setReceiveFromPartyNetAmount,
    setQuickPurchaseTableData,
    setDataSource,
    paymentVoucherTotal,
    setPaymentVoucherTotal,
    setReceiptVoucherHeader,
    receiptVoucherHeader,
    setTaxVat,
    setCategoryIds,
    setGroupIds,
  } = useTransactionContext();
  const { app } = useAppData();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [deleteReferenceId, setDeleteReferenceId] = useState(null);
  const [cancelReferenceId, setCancelReferenceId] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalType, setModalType] = useState('');
  const [columns, setColumns] = useState([]);
  const [startDate, setStartDate] = useState(
    last7DaysObject?.value?.from?.date,
  );
  const [endDate, setEndDate] = useState(last7DaysObject?.value?.to?.date);
  const [searchTerm, setSearchTrem] = useState('');
  const billNo = useDebounce((searchTerm || '').trim(), 400);
  const [tableData, setTableData] = useState([]);
  const [form] = useForm();
  const remarkRef = useRef();
  const [checkList, setCheckList] = useState([]);

  const { data: billTemplateData } = useGetApiListNoToast(
    '/transaction/bill-setup/transaction-type/quotation/',
    {
      params: {
        q: '',
      },
    },
  );

  const { mutateAsync: deleteData, isPending: deleteLoading } = useDeleteApi();
  const { mutateAsync: updateData, isPending: updateLoading } = useUpdateApi();

  const { pathname } = useLocation();

  const {
    mutateAsync: mutateEditApi,
    isPending: loadingPrinter,
    data: printData,
  } = useMutateGetApi();

  const {
    loadMore: loadMoreRows,
    loadingMore: loadingMoreRows,
    hasMore: hasMoreRows,
    metaData: listMetaData,
    searchReport,
    triggerSearch,
    loading,
    setIsSearchClicked,
  } = useSearchReport({
    setPagination,
    setTableData,
    url: '/transaction/quotation/',
    // startDate,
    // endDate,
    startDate: salesStartDate?.[pathname] || last7DaysObject?.value?.from?.date,
    endDate: salesEndDate?.[pathname] || last7DaysObject?.value?.to?.date,
    page: pagination.page,
    pageSize: pagination.pageSize,
    searchParams: { bill_no: billNo },
    infinite: true,
  });
  /**
   * Shows delete confirmation modal.
   * @param {string} referenceId-The referenceId of the ledger to delete
   */
  const showDeleteModal = (referenceId) => {
    setModalType('delete');
    setIsModalVisible(true);
    setDeleteReferenceId(referenceId);
  };
  /**
   * Shows cancel confirmation modal.
   * @param {string} referenceId-The referenceId of the ledger to delete
   */
  const showCancelModal = (referenceId) => {
    setModalType('cancelItem');
    setIsModalVisible(true);
    setCancelReferenceId(referenceId);
    form.setFieldValue('remarks', '');
  };
  /**
   * Hides the modal
   */
  const handleCancel = () => {
    setCancelReferenceId(null);
    setDeleteReferenceId(null);
    setIsModalVisible(false);
  };

  /**
   *Handles search input change.

   * @param {string} value-The search term.
   */

  const handleSearch = (value) => {
    setSearchTrem(value);
  };

  const filteredTableData = tableData;
  const searchSalesOrderList = () => {
    searchReport({
      page: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const [template1, setTemplate1] = useState(false);

  const [template2, setTemplate2] = useState(false);

  const [billTemplateDataCustom, setBillTemplateDataCustom] = useState(null);

  useEffect(() => {
    searchSalesOrderList();
  }, [salesStartDate?.[pathname], salesEndDate?.[pathname], billNo]);

  const componentRef = useRef(null);

  const handleOnBeforeGetContent = useCallback(() => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 10);
    });
  }, []);

  const handleBeforePrint = useCallback(() => {});

  const printTemplate = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: '\u00A0',
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    setSelectedDataSo({
      ledger: '',
      billNo: '',
      entryNo: '',
      entryDate: null,
      item: '',
      code: '',
      ledgerName: '',
      itemName: '',
      cashPaid: 0,
    });
    setReceiveTabledata([
      {
        id: Date.now().toString(),
        item: '',
        code: '',
        gwt: '',
        dsWt: '',
        nwt: '',
        rate: '',
        netWithWastage: '',
        amount: '',
        netAmount: '',
        itemName: '',
      },
    ]);
    setTaxVat({
      isTaxApplicable: false,
    });
    setCategoryIds([]);
    setGroupIds([]);
    setEditApiBlock(false);
    setSalesSelectReferenceId([]);
    setSelectedItems([]);
    setHiddenValueChange(false);
    setQuickPurchaseTableData([]);
    setDataSource([
      {
        key: 0,
        receiveTo: '',
        amount: 0,
        remarks: '',
      },
    ]);

    setReceiptVoucherHeader({
      ...receiptVoucherHeader,
      voucherNo: '',
      voucherDate: '',
      voucherId: null,
      remarks: '',
    });
    setPaymentVoucherTotal(0);

    setSalesOrderSelectedData({
      ledger: '',
      billNo: '',
      entryNo: '',
      entryDate: null,
      item: '',
      code: '',
      ledgerName: '',
      itemName: '',
    });
    setPurchaseFinalJson({});

    setReceiveFromPartyNetAmount(0);

    setpurchaseTableData([{ id: Date.now().toString() }]);
    setSalesOrderTableData([{ id: Date.now().toString() }]);
    setPurchaseNetAmount(0);
    setSelectedData({
      ledger: '',
      billNo: '',
      entryNo: '',
      entryDate: null,
      item: '',
      code: '',
      ledgerName: '',
      itemName: '',
      cashPaid: 0,
    });
    setPrefixResponse({});
    setSalesSelectedData({
      ledger: '',
      billNo: '',
      entryNo: '',
      entryDate: null,
      item: '',
      code: '',
      ledgerName: '',
      itemName: '',
    });
  }, []);

  const actionColumn = {
    title: 'Action',
    key: 'action',
    // fixed: 'right',
    width: '5%',
    align: 'center',
    render: (_, record) =>
      !record?.isCancel ? (
        <div
          style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <EditButton path={`/sales/quotation/edit/${record?.saleOrderId}`} />

          <Button
            type="text"
            loading={loadingPrinter}
            className="tw-cursor-pointer"
            onClick={async () => {
              await mutateEditApi({
                url: `/transaction/quotation/${record?.saleOrderId}/?mode=print`,
              });

              if (
                billTemplateData?.data?.length == 0 ||
                billTemplateData?.data?.length === undefined
              ) {
                message.info('Printing Template not found.');
              }

              if (billTemplateData?.data?.length > 1) {
                setTemplate2(true);
              } else {
                setTemplate1(true);
                printTemplate();
              }
            }}
            icon={
              <PrinterOutlined
                style={{
                  color: 'green',
                  fontSize: 14,
                }}
              />
            }
            style={{
              all: 'unset', // Removes all styles
              cursor: 'pointer',
            }}
          />
          <DeleteModalButton
            showCancelModal={showDeleteModal}
            data={record?.saleOrderId}
          />
        </div>
      ) : null,
  };

  useEffect(() => {
    const dynamicColumns = generateDynamicColumns(tableData);
    const dynamicColumnsModified = dynamicColumns.map((column) => {
      if (column.title === 'S N') {
        return {
          ...column,
          width: 20,
        };
      }
      if (column.title === 'Amount') {
        return {
          ...column,
          render: (value) => {
            return formatNumberWithComma(value);
          },
        };
      }
      if (column.title === 'Advance') {
        return {
          ...column,
          render: (value) => {
            return formatNumberWithComma(value);
          },
          align: 'right',
        };
      }
      return column;
    });
    if (tableData?.length) {
      setColumns([...dynamicColumnsModified, actionColumn]);
    } else {
      setColumns(dynamicColumnsModified);
    }
  }, [tableData]);

  useEffect(() => {
    if (isModalVisible && remarkRef?.current) {
      const { input } = remarkRef?.current;
      setTimeout(() => {
        input?.focus();
      }, 0);
    }
  }, [isModalVisible, remarkRef]);

  const deleteSalesOrderList = async () => {
    if (!deleteReferenceId) return;

    setIsModalVisible(false);
    await deleteData(`/transaction/quotation/${deleteReferenceId}/`);
    triggerSearch();
  };
  const cancelSalesOrderList = async () => {
    if (!cancelReferenceId) return;
    try {
      const values = await form.validateFields(['remarks']);
      const remarkData = values?.remarks;
      setIsModalVisible(false);

      await updateData({
        url: `/transaction/quotation/${cancelReferenceId}/cancel/`,
        values: { remarks: remarkData },
      });

      triggerSearch();
    } catch (error) {
      throw new Error(error?.errorFields?.value?.remarks);
    }
  };

  const remarks = (
    <div>
      <Form form={form}>
        <Form.Item name="remarks" rules={[{ required: true, message: '' }]}>
          <Input ref={remarkRef} placeholder="Enter Remarks" maxLength={30} />
        </Form.Item>
      </Form>
    </div>
  );

  return (
    <div style={{ position: 'relative', top: 0, marginTop: 0, paddingTop: 0 }}>
      <div className="tw-hidden">
        <Back />
      </div>
      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card variant="borderless" className="circlebox tablespace mb-24">
              <ListHeaderComponents
                handleSearch={handleSearch}
                hideExport
                refreshOnDateChange={false}
                // setStartDate={setStartDate}
                // setEndDate={setEndDate}
                startDate={
                  salesStartDate?.[pathname] ||
                  last7DaysObject?.value?.from?.date
                }
                endDate={
                  salesEndDate?.[pathname] || last7DaysObject?.value?.to?.date
                }
                data={filteredTableData}
                columns={columns}
                checkList={checkList}
                setCheckList={setCheckList}
                title={'Quotation'}
                filename={'sales_order'}
                setIsSearchClicked={setIsSearchClicked}
                triggerSearch={triggerSearch}
                createPath="/sales/quotation/create/"
                createButtonTitle="Create New Quotation"
              />

              <DynamicTable
                onLoadMore={loadMoreRows}
                hasMore={hasMoreRows}
                loadingMore={loadingMoreRows}
                metaData={listMetaData}
                data={filteredTableData}
                columns={
                  loading || deleteLoading || updateLoading
                    ? salesOrderSkeletonTableHeader
                    : columns?.map((col) => ({
                        ...col,
                        hidden: !checkList.includes(col.key),
                      }))
                }
                loading={loading || deleteLoading || updateLoading}
                isShowDynamicScroll={true}
                scrollY={true}
              />
            </Card>
          </Col>
        </Row>
      </div>

      <GlobalModal
        isVisible={isModalVisible}
        type={modalType}
        onClose={handleCancel}
        onConfirm={
          deleteReferenceId ? deleteSalesOrderList : cancelSalesOrderList
        }
        remarks={remarks}
      />

      <DraggableModal
        open={template2}
        width={'50%'}
        onCancel={() => {
          setTemplate2(false);
        }}
        title={'Choose Print Template'}
      >
        <Form.Item name={'printTemplate'} initialValue={''}>
          <Select
            style={{
              width: '100%',
            }}
            defaultValue={''}
            options={billTemplateData?.data?.map((item) => ({
              label: item.name,
              value: item.referenceId,
            }))}
            onSelect={(e) => {
              const dataToPrint = billTemplateData?.data?.find(
                (item) => item.referenceId === e,
              );
              setBillTemplateDataCustom(dataToPrint);
              printTemplate();
            }}
          />
        </Form.Item>
      </DraggableModal>
      {template1 &&
        (() => {
          const tpl = billTemplateData?.data?.[0];
          const printFormat = getPrintFormatFromTemplate(
            tpl?.editorConfig,
            tpl?.configuration,
          );
          if (!printFormat) return null;
          return (
            <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
              <PrintFormatRenderer
                ref={componentRef}
                printFormat={printFormat}
                tokenCtx={mapRawSummaryToTokenContext(
                  printData?.data?.summaryData,
                  printData?.data?.detailsData,
                  mapAppToBusiness(app),
                  printData?.data?.goldRateInTola,
                  printData?.data?.silverRateInTola,
                )}
              />
            </div>
          );
        })()}

      {template2 &&
        billTemplateDataCustom &&
        (() => {
          const printFormat = getPrintFormatFromTemplate(
            billTemplateDataCustom?.editorConfig,
            billTemplateDataCustom?.configuration,
          );
          if (!printFormat) return null;
          return (
            <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
              <PrintFormatRenderer
                ref={componentRef}
                printFormat={printFormat}
                tokenCtx={mapRawSummaryToTokenContext(
                  printData?.data?.summaryData,
                  printData?.data?.detailsData,
                  mapAppToBusiness(app),
                  printData?.data?.goldRateInTola,
                  printData?.data?.silverRateInTola,
                )}
              />
            </div>
          );
        })()}
    </div>
  );
};

export default SalesQuotationList;
